AppRun.$inject = ["$http", "$auth", "$rootScope", "$mdToast", "$transitions", "$state"];

function AppRun(http, auth, rootScope, mdToast, transitions, state) {
    let tokenHandler = function () {
        auth.clearStaleState();
        auth.getUser().then(async function (user) {
            console.log(user);
            
            if (user) {
                rootScope.authData = await user;
                http.defaults.headers.common.Authorization = 'Bearer ' + user.access_token;
        
            
            }
            //  else {
            //     location.href = `${location.origin}/#!/Authentication/UserLogin?returnUrl=${encodeURIComponent(location.href)}`
            // }
        });
    }

    let allState = state.get();

    let breadcrumbHandler = function () {

        rootScope.broadcast = [];

        let currentState = state.current;

        if (angular.isDefined(currentState.breadcrumbData)) {
            rootScope.broadcast.push({
                state: currentState.name,
                parent: currentState.breadcrumbData.parent,
                title: currentState.breadcrumbData.title,
                icon: currentState.breadcrumbData.icon
            })

            function getParentState(state) {
                if (angular.isDefined(state.breadcrumbData.parent)) {
                    let parentState = allState.find(stateInfo => stateInfo.name === state.breadcrumbData.parent)
                    if (angular.isDefined(parentState.breadcrumbData)) {
                        rootScope.broadcast.push({
                            state: parentState.name,
                            parent: parentState.breadcrumbData.parent,
                            title: parentState.breadcrumbData.title,
                            icon: parentState.breadcrumbData.icon,
                        })
                    }
                    if (angular.isDefined(state.breadcrumbData) && angular.isDefined(parentState.breadcrumbData)) {
                        getParentState(parentState)
                    }
                }
            }

            getParentState(currentState)

            rootScope.broadcast.push({
                state: "Dashboard.Index",
                parent: "",
                title: "پنل کاربری",
                icon: "fas fa-home"
            })
        }

        rootScope.broadcast.reverse()
    }

    var logOutHandler = async function () {
        await auth.removeUser();
        mdToast.show(
            mdToast.simple()
            .textContent('شما از شبکه نوآوری خارج شده اید.')
            .position('bottom right')
            .theme("error-toast")
            .hideDelay(3000)
        );
        setTimeout(() => {
            location.href = location.origin
        }, 3000);
    }

    // if (location.hostname != "localhost")
    //     auth.addUserSignedOut(logOutHandler);

    tokenHandler();
    rootScope.$on('$locationChangeStart', function (event, next, current) {
        tokenHandler()
    });

    rootScope.$on('$locationChangeSuccess', function () {
        rootScope.currentState = state;
    });

    transitions.onSuccess({}, function (transition) {
        if (angular.isDefined(transition.to().controllerAs)) {
            breadcrumbHandler()
        }
    });

}

export default AppRun;